import { CdkDragDrop } from "@angular/cdk/drag-drop";
import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatMenuTrigger } from "@angular/material/menu";
import {
  faChevronCircleLeft,
  faChevronCircleRight,
  faSearch,
} from "@fortawesome/pro-light-svg-icons";
import {
  faCalendarDay,
  faCheckSquare,
  faFile,
  faFolderTree,
  faHashtag,
  faHistory,
  faLink,
  faStopwatch,
  faTally,
  faText,
  faTextSize,
  faUsdCircle,
  faUser,
  faUserTie,
} from "@fortawesome/pro-regular-svg-icons";
import { faTrash } from "@fortawesome/pro-solid-svg-icons";
import { CommonService } from "@services/common.service";
import { moveItemInFormArray } from "../../../shared/move-item-in-form-array";

@Component({
    selector: "app-filter-logic",
    templateUrl: "./filter-logic.component.html",
    styleUrls: ["./filter-logic.component.scss"],
    standalone: false
})
export class FilterLogicComponent implements OnInit {
  public filterFields: any[] = [];
  public filterdata: any[] = [];
  public dataFields: any[] = [];
  public filterLogicMapping: any[] = [];
  @ViewChild("scroll", { read: ElementRef }) public scroll!: ElementRef;

  constructor(
    private fb: UntypedFormBuilder,
    public commonService: CommonService,
    public dialogRef: MatDialogRef<FilterLogicComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.filterFields = data.filterFields;
    this.filterLogicMapping = data.filterLogicMapping;
  }
  public categories: any = [];
  faTrash = faTrash;
  faChevronCircleLeft = faChevronCircleLeft;
  faChevronCircleRight = faChevronCircleRight;
  faSearch = faSearch;
  public filterLogic?: string;
  public filterLogicUser?: string;
  public error: string = "";
  selectedIndex = -1;
  darrinTestingFlag: boolean = true;

  @ViewChild("fieldMenuTrigger") fieldMenuTrigger!: MatMenuTrigger;
  selectFilter(condition: boolean, filterID: any) {
    if (condition) {
      this.selectedIndex = filterID;
    } else {
      this.selectedIndex = -1;
    }
  }
  getIconByType(type: string) {
    let icon: any;
    switch (type) {
      case "text":
      case "text_editor":
        icon = faText;
        break;
      case "textarea":
        icon = faTextSize;
        break;
      case "owned_by":
        icon = faUser;
        break;
      case "date":
        icon = faCalendarDay;
        break;
      case "select":
      case "select_multiple":
        icon = faHashtag;
        break;
      case "integer":
      case "number":
        icon = faTally;
        break;
      case "checkbox":
        icon = faCheckSquare;
        break;
      case "employee":
        icon = faUserTie;
        break;
      case "created":
      case "updated":
        icon = faHistory;
        break;
      case "document":
        icon = faFile;
        break;
      case "currency":
        icon = faUsdCircle;
        break;
      case "auto_counter":
        icon = faStopwatch;
        break;
      case "linked_record":
        icon = faFolderTree;
        break;
      case "hyperlink":
        icon = faLink;
        break;
      default:
        icon = faText;
        break;
    }
    return icon;
  }
  getIconColor(id: number) {
    let selected = this.categories.filter(function (module: any) {
      return module.id == id;
    });
    if (selected.length < 1) {
    } else {
      return selected[0]["color"];
    }
  }

  onConfirmClick(): void {
    this.filterLogicMapping = this.filterForm!.get(
      "filterConditionList"
    )!.value;
    const data = {
      mappingString: this.filterLogic,
      mappingList: this.filterLogicMapping,
    };
    this.dialogRef.close(data);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  conditionalColor(id: number) {
    let returnVal = {};
    let conditionItem = this.filterForm.get(
      "filterConditionList"
    ) as UntypedFormArray;
    const currentFieldLevel =
      conditionItem.controls[id].get("filterLevel")!.value;
    const nextFieldLevel =
      conditionItem.controls[id + 1].get("filterLevel")!.value;
    if (currentFieldLevel > 0 && currentFieldLevel == nextFieldLevel) {
      const level = currentFieldLevel * 40 + "px";
      returnVal = { color: "#dfe1e6", "margin-left": level };
    }
    return returnVal;
  }
  taskForm!: UntypedFormGroup;

  public disabled = false;
  selectedToAdd: any;
  selectedToRemove: any;
  selectedItems: any = [];
  roleArray: any = [];
  selectedFields: any = [];
  selectedTasks: any = [];

  filterForm!: UntypedFormGroup;
  filterConditionList!: UntypedFormArray;

  new = true;

  public conditionsListing: any[] = [];
  get filterFormGroups() {
    return this.filterForm.get("filterConditionList") as UntypedFormArray;
  }

  createItem(id: number, condition?: string, level?: any): UntypedFormGroup {
    return this.fb.group({
      filterId: [id, [Validators.required]],
      filterOperation: [condition || "and"],
      filterLevel: [level || 0],
    });
  }

  addItem(id: any, condition?: string, level?: any): void {
    this.filterConditionList = this.filterForm.get(
      "filterConditionList"
    ) as UntypedFormArray;
    this.filterConditionList.push(this.createItem(id, condition, level));
    this.filterForm.get("filterConditionList")!.markAllAsTouched();
  }

  addFilter() {
    this.addItem(null);

    setTimeout(() => {
      this.scrollToBottom();
    }, 100);
  }

  public scrollToBottom() {
    this.scroll.nativeElement.scrollTop =
      this.scroll.nativeElement.scrollHeight;
  }

  deleteItem(idx: number) {
    this.filterConditionList = this.filterForm.get(
      "filterConditionList"
    ) as UntypedFormArray;
    this.filterConditionList.removeAt(idx);
  }

  getNameById(id: any, type: any) {
    if (type == "id") return id;
    if (type == "") return "undefined";
    if (id) {
      let item = this.filterFields.filter(function (element: any) {
        if (element.id) {
          return element.id == id;
        } else {
          return element.dataPoint.data.id == id;
        }
      });

      let name = item[0].name || item[0].dataPoint.data.name;

      name = name.split(" ").join("_");
      return name;
    }
    return "Unknown";
  }
  groupItem(operation: string, idx: number) {
    var arrayControl = this.filterForm.get(
      "filterConditionList"
    ) as UntypedFormArray;
    var item = arrayControl.at(idx);
    let currentLevel = item.get("filterLevel")!.value;

    if (operation == "right") {
      if (currentLevel < 4)
        item.get("filterLevel")!.patchValue(currentLevel + 1);
    } else {
      if (currentLevel > 0)
        item.get("filterLevel")!.patchValue(currentLevel - 1);
    }
  }
  indentItem(idx: number): object {
    var arrayControl = this.filterForm.get(
      "filterConditionList"
    ) as UntypedFormArray;
    let item = arrayControl.at(idx);
    let color = "";
    let textColor = "#7a869a";
    let styles = {};
    let level = item.get("filterLevel")!.value;
    if (level > 0 && level < 5) {
      switch (level) {
        case 0:
          color = "#F4F5F7";
          break;
        case 1:
          color = "#dcddde";
          break;
        case 2:
          color = "#c3c4c6";
          break;
        case 3:
          color = "#abacad";
          textColor = "#ebecf0";
          break;
        case 4:
          color = "#929394";
          textColor = "#ebecf0";
          break;
      }
      level = level * 40;
      let width = "calc(100% - (" + (20 + level) + "px)";
      styles = {
        "margin-left": level + "px",
        width: width,
        color: textColor,
        "background-color": color,
      };
    }
    this.generate();
    return styles;
  }
  indentCondition(idx: number): object {
    var arrayControl = this.filterForm.get(
      "filterConditionList"
    ) as UntypedFormArray;
    let item = arrayControl.at(idx);
    let color = "";
    let styles = {};
    let level = item.get("filterLevel")!.value;
    if (level > 0 && level < 5) {
      switch (level) {
        case 0:
          color = "#F4F5F7";
          break;
        case 1:
          color = "#dcddde";
          break;
        case 2:
          color = "#c3c4c6";
          break;
        case 3:
          color = "#abacad";
          break;
        case 4:
          color = "#929394";
          break;
      }
      level = level * 40;

      styles = {
        "margin-left": level + "px",
        "background-color": color,
      };
    }
    return styles;
  }
  checkLeft(idx: number): object {
    var arrayControl = this.filterForm.get(
      "filterConditionList"
    ) as UntypedFormArray;
    var item = arrayControl.at(idx);
    var level = item.get("filterLevel")!.value;
    let returnVal = {};
    if (level == 0) returnVal = { color: "transparent" };
    return returnVal;
  }
  checkRight(idx: number): object {
    var arrayControl = this.filterForm.get(
      "filterConditionList"
    ) as UntypedFormArray;
    var item = arrayControl.at(idx);
    var level = item.get("filterLevel")!.value;
    let returnVal = {};
    if (level >= 4) returnVal = { color: "transparent" };
    return returnVal;
  }

  changeFilter(id: any, condition: string) {
    let conditionItem = this.filterForm.get(
      "filterConditionList"
    ) as UntypedFormArray;
    conditionItem.controls[id].get("filterOperation")!.setValue(condition);
  }
  get conditionControls(): UntypedFormArray {
    return this.filterForm.get("filterConditionList") as UntypedFormArray;
  }

  drop(event: CdkDragDrop<string[]>) {
    var arrayControl = this.filterForm.get(
      "filterConditionList"
    ) as UntypedFormArray;

    var item = arrayControl.at(event.previousIndex);
    var item2 = arrayControl.at(event.currentIndex);

    item.get("filterLevel")!.setValue(item2.get("filterLevel")!.value);

    moveItemInFormArray(
      this.conditionControls,
      event.previousIndex,
      event.currentIndex
    );
  }

  generate() {
    this.filterLogic = this.generateLogic("id");
    this.filterLogicUser = this.generateLogic("name");
    this.filterLogicUser = this.filterLogicUser
      .split("_")
      .join(" ")
      .split(")")
      .join("<span class=paren>)</span>")
      .split("(")
      .join("<span class=paren>(</span>");
  }
  generateLogic(type: string) {
    const tempList = this.filterForm!.get("filterConditionList")!.value;

    let logicListDisplay = "";
    let x: any;
    let y: any;
    let z: any;
    tempList.forEach((element: any, index: number) => {
      if (index == 0 && tempList[index].filterLevel > 0) {
        for (let temp = 0; temp < tempList[index].filterLevel; temp++) {
          logicListDisplay += " ( ";
        }
      }
      logicListDisplay +=
        " " +
        this.getNameById(element.filterId, type) +
        " " +
        element.filterOperation;

      if (tempList[index + 1]) {
        if (tempList[index + 1].filterLevel > tempList[index].filterLevel) {
          for (
            let temp = 0;
            temp <
            Math.abs(
              tempList[index].filterLevel - tempList[index + 1].filterLevel
            );
            temp++
          ) {
            logicListDisplay += " ( ";
          }
        }
        if (tempList[index].filterLevel > tempList[index + 1].filterLevel) {
          x = logicListDisplay.split(" ");
          z = x.pop();
          y = x.slice(0, -1);
          logicListDisplay =
            y.join(" ") + " " + this.getNameById(element.filterId, type) + " ";
          for (
            let temp = 0;
            temp <
            tempList[index].filterLevel - tempList[index + 1].filterLevel;
            temp++
          ) {
            logicListDisplay += " ) ";
          }
          logicListDisplay += z;
        }
      } else {
        if (element.filterLevel != 0) {
          x = logicListDisplay.split(" ");
          z = x.pop();
          y = x.slice(0, -1);
          logicListDisplay =
            y.join(" ") + " " + this.getNameById(element.filterId, type) + " ";
          for (let temp = 0; temp < tempList[index].filterLevel; temp++) {
            logicListDisplay += " ) ";
          }
          logicListDisplay += z;
        }
      }
    });
    x = logicListDisplay.split(" ");
    y = x.slice(0, -1);
    logicListDisplay = y.join(" ");

    logicListDisplay = logicListDisplay.replace(/\s+/g, "");
    logicListDisplay = logicListDisplay
      .split("and")
      .join(" and ")
      .split("or")
      .join(" or ");

    return logicListDisplay;
  }
  ngOnInit(): void {
    this.filterForm = this.fb.group({
      filterConditionList: this.fb.array([]),
      field: new UntypedFormControl(),
      collection: new UntypedFormControl(),
    });
    if (this.filterLogicMapping && this.filterLogicMapping.length > 0) {
      this.filterLogicMapping.forEach((element, index) => {
        this.addItem(
          element.filterId,
          element.filterOperation,
          element.filterLevel
        );
      });
    } else {
      if (this.filterFields) {
        this.filterFields.forEach((element, index) => {
          element.index = index;
          let condition = "and";
          if (index < this.filterFields.length - 1)
            condition = this.filterFields[index + 1].fields.data[0].condition;
          this.addItem(element.id || element.dataPoint.data.id, condition);
        });
      }
    }
  }
}
